<template>
    <div id="app">
        <div class="container">
            <router-view/>
        </div>
    </div>
</template>

<script>
    export default {
        name: "AppPassword"
    }
</script>

<style scoped>
    #app, .container {
        height: 100%;
    }

</style>